export default "__VITE_ASSET__SiE4AxuR__"